
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  BufferTypes,
  HeatExchangerFlowDirection,
  HeatingCircuitRadiatorTypes,
  HeatingCircuitTemperatureControlHardware,
  HeatingCircuitTypes,
  HeatingSystem,
  HeatingSystemComponent,
  HeatingSystemMetadata,
  HeatingSystemMetadataKey,
  HeatingSystemMetadataResponse,
  TeleHeatingType,
  TemperatureControlParameter,
  WarmPumpEnergySource,
  WarmPumpHeatSinkType,
  WaterHeatingTypes,
} from '@/features/core/store/page-modules/heating-systems-metadata/heating-systems-metadata.module';
import { Option } from '@/features/ui/inputs/model';
import { defineComponent, PropType } from '@vue/composition-api';
import { mapGetters, mapState } from 'vuex';
import Spinner from '@/components/clickables/Spinner.vue';
import { GetAtRegulationConfig_atRegulationConfig } from '../__generated__/GetAtRegulationConfig';
import { HeatingControlType } from '@/types/iot-portal';
import { cloneDeep } from 'lodash';
import { getFormDataForHeatingCircuit, getFormDataForTeleHeating } from '@/util/heatingSystemsMetadataUtils';

type ErrorMessage = {
  field: string;
  message: string;
};

const form: HeatingSystemMetadata = {
  boiler: {
    condensing: null,
    wall_mounted: null,
    return_temp_uplift: null,
    safety_temp_guard: null,
    safety_temp_limiter: null,
    cascade: null,
    is_modulating: null,
    has_own_pump: null,
    has_regulating_valve: null,
    has_check_valve: null,
    system_separation: null,
    power_max_out: null,
    power_min_out: null,
    has_hydraulic_shunt: null,
  },
  waterHeating: {
    type_of_pwh: null,
    potable_water_target_temp: null,
    potable_water_temperature_tolerance: null,
    circulation_target_temp: null,
    circulation_temperature_tolerance: null,
  },
  buffer: {
    type: null,
    upper_limit: null,
    lower_limit: null,
    prim_port_energy_input: null,
    sec_port_energy_input: null,
    tert_port_energy_input: null,
    quart_port_energy_input: null,
    two_sensors_controlled: null,
  },
  heatingCircuit: {
    control_parameter: {
      type: null,
      summer_shutdown_temp: null,
      nightly_reduced_temperature: null,
      minimum_temperature: null,
      maximum_temperature: null,
      supply_potable_water_heating: null,
      room_target_temperature: null,
      offset: null,
      slope: null,
      target_temperature: null,
      env_flow_temp_points: [[0, 0]],
    },
    radiator_type: null,
    heating_circuit_building_year: null,
    temperature_control_hardware: null,
    execute_oscillation_analysis: null,
  },
  teleHeating: {
    system_separation: null,
    teleheating_type: null,
    safety_temp_guard: null,
    safety_temp_limiter: null,
    temperature_control_type: null,
    flow_temperature_control_parameter: {
      type: 'pointed_curve',
      target_temperature: null,
      pointed_curve_parameter: [[], []],
    },
    return_temperature_control_parameter: {
      type: 'constant_temperature',
      target_temperature: 57,
      pointed_curve_parameter: [[], []],
    },
  },
  chp: {
    th_power_max_out: null,
    el_power_max_out: null,
    power_gt_2mw: null,
  },
  warmPumpPrimary: {
    supply_potable_water_heating: null,
    cop_at_design: null,
    energy_source_type: null,
    heat_sink_type: null,
    has_buffer: null,
    has_heating_element: null,
    cooling_mode_available: null,
    cascade: null,
  },
  warmPumpSecondary: {
    supply_potable_water_heating: null,
    cop_at_design: null,
    energy_source_type: null,
    heat_sink_type: null,
    has_buffer: null,
    has_heating_element: null,
    cooling_mode_available: null,
    cascade: null,
  },
  heatExchangerPrimary: {
    terminal_temperature_difference: null,
    design_power: null,
    flow_direction: null,
  },
  heatExchangerSecondary: {
    terminal_temperature_difference: null,
    design_power: null,
    flow_direction: null,
  },
  heatingControlOutsideTemperature: {
    yearOfConstruction: null,
    heatedArea: null,
    type: null,
    forecastHours: null,
  },
};

export default defineComponent({
  components: {
    Spinner,
  },
  props: {
    meta: {
      type: Object as PropType<HeatingSystemMetadataKey>,
      required: true,
    },
  },
  emits: ['form-saved'],
  data() {
    return {
      options: [
        {
          label: 'ja',
          value: true,
        },
        {
          label: 'nein',
          value: false,
        },
      ] as Option[],
      waterHeatingOptions: [
        {
          label: 'Frischwasserstation',
          value: WaterHeatingTypes.FRESH_WATER_STATION,
        },
        {
          label: 'Speicherladesystem',
          value: WaterHeatingTypes.BUFFER_CHARGING_SYSTEM,
        },
        {
          label: 'Heizwendelspeicher',
          value: WaterHeatingTypes.BUFFER_HEATING_COIL_SYSTEM,
        },
      ],
      bufferTypeOptions: [
        { label: 'Solar', value: BufferTypes.SOLAR },
        { label: 'Wärmespeicher', value: BufferTypes.HEAT_ENERGY_STORAGE },
        { label: 'Trinkwasserbereitung', value: BufferTypes.POTABLE_WATER },
      ],
      heatingCircuitHardwareOptions: [
        { label: 'Drosselschaltung', value: HeatingCircuitTemperatureControlHardware.FLOW_CTRL_VALVE },
        { label: 'Differenzdruckgeregelt', value: HeatingCircuitTemperatureControlHardware.DIFF_PRESSURE_CTRL },
        { label: 'Umlenkschaltung', value: HeatingCircuitTemperatureControlHardware.FLOW_DIVERTED },
        { label: 'Einspritzschaltung', value: HeatingCircuitTemperatureControlHardware.INJECTION_UNIT },
        { label: 'Durchgangsventil', value: HeatingCircuitTemperatureControlHardware.INLINE_VALVE },
        { label: 'Doppelte Beimischschaltung', value: HeatingCircuitTemperatureControlHardware.DOUBLE_ADMIX },
        { label: 'Einfache Beimischschaltung', value: HeatingCircuitTemperatureControlHardware.SINGLE_ADMIX },
        { label: 'Ungemischt', value: HeatingCircuitTemperatureControlHardware.UNMIXED },
      ],
      heatingCircuitRadiatorOptions: [
        { label: 'Normale Heizkörper', value: HeatingCircuitRadiatorTypes.CONVENTIONAL_RADITOR },
        { label: 'Lüftungsanlage', value: HeatingCircuitRadiatorTypes.VENTILATION },
        { label: 'Fußbodenheizung', value: HeatingCircuitRadiatorTypes.UNDERFLOOR_HEATING },
      ],
      heatingCircuitControlParameterOptions: [
        { label: 'Automatisch', value: HeatingCircuitTypes.AUTOMATIC },
        { label: 'Parametrisierte Kurve', value: HeatingCircuitTypes.PARAMETERIZED_CURVE },
        { label: 'Kurve auf Basis von Eckpunkten', value: HeatingCircuitTypes.POINTED_CURVE },
        { label: 'Konstante Temperatur', value: HeatingCircuitTypes.CONSTANT_TEMPERATURE },
      ],
      teleHeatingOptions: [
        {
          label: 'Einfach',
          value: TeleHeatingType.SINGLE,
        },
        {
          label: 'Doppelt',
          value: TeleHeatingType.DUAL,
        },
        {
          label: 'Direkt',
          value: TeleHeatingType.DIRECT,
        },
      ],
      teleHeatingTemperatureControlOptions: [
        {
          label: 'Kurve auf Basis von Eckpunkten',
          value: 'pointed_curve',
        },
        {
          label: 'Konstante Temperatur',
          value: 'constant_temperature',
        },
      ],
      warmPumpEnergySourceOptions: [
        {
          label: 'Luft',
          value: WarmPumpEnergySource.AIR,
        },
        {
          label: 'Wasser',
          value: WarmPumpEnergySource.WATER,
        },
        {
          label: 'Sole',
          value: WarmPumpEnergySource.BRINE,
        },
      ],
      warmPumpHeatSinkTypeOptions: [
        {
          label: 'Luft',
          value: WarmPumpHeatSinkType.AIR,
        },
        {
          label: 'Wasser',
          value: WarmPumpHeatSinkType.WATER,
        },
      ],
      heatExchangerFlowDirectionOptions: [
        {
          label: 'Gegenstrom',
          value: HeatExchangerFlowDirection.COUNTER_CURRENT,
        },
        {
          label: 'Gleichstrom',
          value: HeatExchangerFlowDirection.DIRECT_CURRENT,
        },
      ],
      heatingControlOutsideTemperatureOptions: [
        {
          label: 'Heizkörper',
          value: HeatingControlType.RADIATOR,
        },
        {
          label: 'Boden',
          value: HeatingControlType.FLOOR,
        },
      ],
      form,
      requestType: 'create' as 'create' | 'edit',
      lastChange: {
        user: null as string | null,
        date: null as Date | null,
      },
      timer: null as number | null,
      errors: [] as ErrorMessage[],
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters(['openModal']),
    ...mapState({
      activeHeatingSystemAtRegulationConfig: (state: any) =>
        state.HeatingSystemsMetadataModule.activeHeatingSystemAtRegulationConfig,
    }),
    heatingSystems(): HeatingSystem[] {
      return this.$store.getters.heatingSystems;
    },
    heatingSystemsComponents(): HeatingSystemComponent[] {
      return this.$store.getters.heatingSystemsComponents;
    },
    componentType(): string {
      return this.activeHeatingSystemComponent?.type || '';
    },
    hasEditableHeatingControlRegister(): boolean {
      return this.activeHeatingSystemComponent?.hasEditableRegister || false;
    },
    currentYear(): number {
      return new Date().getFullYear();
    },
    activeHeatingSystem(): HeatingSystem | undefined {
      return this.$store.getters.activeHeatingSystem;
    },
    activeHeatingSystemComponent(): HeatingSystemComponent | undefined {
      return this.$store.getters.activeHeatingSystemComponent;
    },
    openApplySettings(): boolean {
      return this.$store.getters.openApplySettings;
    },
    formData(): HeatingSystemMetadata {
      return this.$store.getters.formData;
    },
    heatingSystemsMetadata(): HeatingSystemMetadataResponse[] {
      return this.$store.getters.heatingSystemsMetadata;
    },
    idsToApplySettings(): string[] {
      return this.$store.getters.idsToApplySettings;
    },
    hasAtRegulation(): boolean {
      return (
        this.activeHeatingSystemAtRegulationConfig && this.activeHeatingSystemAtRegulationConfig?.response !== null
      );
    },
  },
  watch: {
    meta: {
      immediate: true,
      deep: true,
      handler(val: HeatingSystemMetadataKey) {
        if (this.componentType !== 'HEATING_CONTROL') {
          this.populateFormData(cloneDeep(val));
        }
      },
    },
    activeHeatingSystemAtRegulationConfig: {
      immediate: true,
      handler(val: GetAtRegulationConfig_atRegulationConfig | null) {
        if (val && val.response) {
          this.form = {
            ...this.form,
            heatingControlOutsideTemperature: {
              ...this.form.heatingControlOutsideTemperature,
              yearOfConstruction: val.response?.buildingYear,
              heatedArea: val.response?.heatedArea,
              type: val.response?.radiatorType,
              forecastHours: val.response?.forecastHours,
            },
          };
        } else if (this.componentType === 'HEATING_CONTROL') {
          this.form = cloneDeep(form);
        }
      },
    },
  },
  mounted() {
    if (this.activeHeatingSystem?.metadata) {
      this.form = this.activeHeatingSystem.metadata;
    }
  },
  methods: {
    initializeTeleHeatingControlParameters(data: string, type: string) {
      if (data && data === 'pointed_curve') {
        if (type === 'flow') {
          this.form.teleHeating.flow_temperature_control_parameter.pointed_curve_parameter = this.form.teleHeating
            .flow_temperature_control_parameter.pointed_curve_parameter ?? [[], []];
        } else {
          this.form.teleHeating.return_temperature_control_parameter.pointed_curve_parameter = this.form.teleHeating
            .return_temperature_control_parameter.pointed_curve_parameter ?? [[], []];
        }
      }
    },
    initializeHeatingCircuitControlParameters(data: string) {
      this.form.heatingCircuit.control_parameter.type = data as HeatingCircuitTypes;
      this.form.heatingCircuit = getFormDataForHeatingCircuit(this.form.heatingCircuit);

      if (data === HeatingCircuitTypes.POINTED_CURVE) {
        this.form.heatingCircuit.control_parameter.env_flow_temp_points = this.form.heatingCircuit.control_parameter
          .env_flow_temp_points?.length
          ? this.form.heatingCircuit.control_parameter.env_flow_temp_points
          : [[], []];
      }
    },
    heatingControlOutsideTemperatureYearLabel() {
      return `1500...${this.currentYear}`;
    },
    closeModal() {
      this.$store.commit('openModal', false);
    },
    onCopyMetadata() {
      this.$store.commit('openApplySettings', !this.openApplySettings);
    },
    async activateAtRegulation() {
      this.validateForm();
      if (this.errors.length > 0) {
        // show error messages
        this.$store.dispatch('ADD_TOAST_MESSAGES', {
          messages: this.errors.map(({ message }) => ({ text: message, class: 'error' })),
          duration: 10000,
        });
        // close "apply settings" panel if it was open
        this.$store.commit('openApplySettings', false);
      } else {
        // Call mutation to activate AT Regulation settings
        const spotId = this.activeHeatingSystemComponent?.value;
        const result = await this.$store.dispatch('activateAtControlRegulationConfig', {
          buildingYear: this.form.heatingControlOutsideTemperature.yearOfConstruction,
          forecastHours: this.form.heatingControlOutsideTemperature.forecastHours,
          heatedArea: this.form.heatingControlOutsideTemperature.heatedArea,
          radiatorType: this.form.heatingControlOutsideTemperature.type,
          spotId,
          apolloClient: this.$apollo,
        });

        if (result && spotId) {
          try {
            await this.$store.dispatch('getATRegulationConfigStatuses', {
              spotIds: [spotId],
              apolloClient: this.$apollo,
            });
          } catch (e) {
            // ignore - store action already logs errors; optionally show toast
          }
        }
      }
    },
    async deactivateAtRegulation() {
      if (this.hasAtRegulation) {
        const spotId = this.activeHeatingSystemComponent?.value;
        const success = await this.$store.dispatch('deactivateAtRegulationConfigMutation', {
          spotId,
          apolloClient: this.$apollo,
        });
        if (success && spotId) {
          try {
            await this.$store.dispatch('getATRegulationConfigStatuses', {
              spotIds: [spotId],
              apolloClient: this.$apollo,
            });
          } catch (e) {
            // ignore - store action already logs errors; optionally show toast
          }
        }
      }
    },
    async saveForm() {
      this.$store.commit('setFormData', this.form);
      this.validateForm();
      if (this.errors.length > 0) {
        // show error messages
        this.$store.dispatch('ADD_TOAST_MESSAGES', {
          messages: this.errors.map(({ message }) => ({ text: message, class: 'error' })),
          duration: 10000,
        });
        // close "apply settings" panel if it was open
        this.$store.commit('openApplySettings', false);
      } else {
        // save data
        try {
          this.isProcessing = true;
          const componentType = this.activeHeatingSystemComponent?.type;
          const spotId = this.activeHeatingSystemComponent?.value;
          const heatingSystemId = this.activeHeatingSystem?.components.id;
          if (componentType && spotId) {
            const metadata = this.getFormData(componentType);
            if (this.requestType === 'create') {
              // create new metadata entry
              await this.$store.dispatch('addHeatingSystemMetadata', {
                spotId,
                heatingSystemId,
                componentType,
                metadata,
              });
            } else {
              // update metadata entry
              await this.$store.dispatch('updateHeatingSystemMetadata', {
                spotId,
                heatingSystemId,
                componentType,
                metadata,
              });
            }

            if (metadata) {
              this.saveApplySettings(metadata);
            }

            this.$emit('form-saved');

            this.$store.dispatch('ADD_TOAST_MESSAGES', {
              messages: [{ text: 'Metadaten erfolgreich gespeichert', class: 'success' }],
            });
          }
        } catch (error) {
          this.$store.dispatch('ADD_TOAST_MESSAGES', {
            messages: [{ text: 'There was a problem saving metadata', class: 'error' }],
          });
        } finally {
          this.isProcessing = false;
        }
      }
    },
    saveApplySettings(metadata: HeatingSystemMetadataKey) {
      this.idsToApplySettings.forEach((id) => {
        // get the heating system data
        const hs = this.heatingSystems.find((item) => item.components.id === id);
        hs?.components.heatingSystemMeasurementGroups.forEach((group) => {
          const componentType = group.systemComponentTypeName;
          // NB: all measurements are using the same spotId
          const spotId = group.heatingSystemMeasurements[0]?.spotId ?? null;
          // apply/copy settings only if the component type is the same
          if (this.componentType === componentType) {
            if (this.metadataExists(id, spotId)) {
              // update settings
              this.$store.dispatch('updateHeatingSystemMetadata', {
                spotId,
                heatingSystemId: id,
                componentType,
                metadata,
              });
            } else {
              // add settings
              this.$store.dispatch('addHeatingSystemMetadata', {
                spotId,
                heatingSystemId: id,
                componentType,
                metadata,
              });
            }
          }
        });
      });
    },
    metadataExists(heatingSystemId: string, spotId: string): boolean {
      return this.heatingSystemsMetadata.find(
        (item) => item.heatingsystemId === heatingSystemId && item.spotId === spotId,
      )
        ? true
        : false;
    },
    getFormData(componentType: string) {
      switch (componentType) {
        case 'BOILER':
          return this.formData['boiler'];
        case 'BUFFER':
          return this.formData['buffer'];
        case 'WARM_HEATING':
          return this.formData['waterHeating'];
        case 'HEATING_CIRCUIT':
          return getFormDataForHeatingCircuit(this.formData['heatingCircuit']);
        case 'TELE_HEATING':
          return getFormDataForTeleHeating(this.formData['teleHeating']);
        case 'HEAT_PUMP_PRIMARY':
          return this.formData['warmPumpPrimary'];
        case 'HEAT_PUMP_SECONDARY':
          return this.formData['warmPumpSecondary'];
        case 'HEAT_EXCHANGER_PRIMARY':
          return this.formData['heatExchangerPrimary'];
        case 'HEAT_EXCHANGER_SECONDARY':
          return this.formData['heatExchangerSecondary'];
        case 'COMBINED_HEAT_POWER_PLANT':
          return this.formData['chp'];
        default:
          return null;
      }
    },
    onNumberFieldChange(field: string, value: number) {
      // debounce the input value
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
        this.validateNumber(field, value);
      }, 800);
    },
    // eslint-disable-next-line complexity
    validateForm(): void {
      this.errors = [];
      if (this.activeHeatingSystemComponent?.hasEditableRegister) {
        for (const [key, value] of Object.entries(this.form.heatingControlOutsideTemperature)) {
          const componentKey = `heatingControl.${key}`;
          const requiredNumberFields = ['heatedArea', 'forecastHours', 'yearOfConstruction'];
          if (requiredNumberFields.includes(key)) {
            this.validateNumber(componentKey, value);
          }
        }
        return;
      }
      switch (this.componentType) {
        case 'BOILER':
          for (const [key, value] of Object.entries(this.form.boiler)) {
            const componentKey = `boiler.${key}`;
            if (key === 'condensing') {
              this.validateSelection(componentKey, value);
            }
            const numberFields = ['safety_temp_guard', 'safety_temp_limiter', 'power_min_out', 'power_max_out'];
            if (numberFields.includes(key)) {
              this.validateNumber(componentKey, value);
            }
          }
          break;
        case 'WARM_HEATING':
          for (const [key, value] of Object.entries(this.form.waterHeating)) {
            const componentKey = `waterHeating.${key}`;
            if (key === 'type_of_pwh') {
              this.validateSelection(componentKey, value);
            }
            const requiredNumberFields = [
              'potable_water_target_temp',
              'potable_water_temperature_tolerance',
              'circulation_target_temp',
              'circulation_temperature_tolerance',
            ];
            if (requiredNumberFields.includes(key)) {
              this.validateNumber(componentKey, value);
            }
          }
          break;
        case 'BUFFER':
          for (const [key, value] of Object.entries(this.form.buffer)) {
            const componentKey = `buffer.${key}`;
            const requiredNumberFields = ['upper_limit', 'lower_limit'];
            if (requiredNumberFields.includes(key)) {
              this.validateNumber(componentKey, value);
            }
          }
          break;
        case 'HEATING_CIRCUIT':
          // Radiator type mandatory
          if (!this.form.heatingCircuit.radiator_type) {
            this.errors.push({
              field: 'heatingCircuit.radiator_type',
              message: 'Radiatortyp ist erforderlich',
            });
          }

          // validate "control parameter" fields
          for (const [key, value] of Object.entries(this.form.heatingCircuit.control_parameter)) {
            if (key === 'type' && !value) {
              this.errors.push({
                field: key,
                message: 'Regelungsparameter ist erforderlich',
              });
            }
            const type = this.form.heatingCircuit.control_parameter?.type;
            if (type === 'pointed_curve' && key === 'env_flow_temp_points' && typeof value === 'object') {
              if (Array.isArray(value) && value.length < 2) {
                this.errors.push({
                  field: key,
                  message: 'Bitte geben Sie mindestens 2 Wertepaare an',
                });
              } else if (this.isAnyTemperaturePairEmpty(value as number[][])) {
                this.errors.push({
                  field: key,
                  message: 'Vorlauftemperaturpunkte der Umgebung Es dürfen keine leeren Wertepaare enthalten sein.',
                });
              }
            } else if (type === 'constant_temperature' && key === 'target_temperature') {
              this.validateNumber(`heatingCircuit.control_parameter.${key}`, value);
            } else if (
              type === 'parameterized_curve' &&
              (key === 'offset' || key === 'slope' || key === 'room_target_temperature')
            ) {
              this.validateNumber(`heatingCircuit.control_parameter.${key}`, value);
            }
          }
          break;
        case 'TELE_HEATING':
          for (const [key, value] of Object.entries(this.form.teleHeating)) {
            const componentKey = `teleHeating.${key}`;
            // Make system_separation mandatory
            if (key === 'system_separation') {
              if (value === null || value === undefined) {
                this.errors.push({
                  field: componentKey,
                  message: 'Systemtrennung ist erforderlich',
                });
              }
            }
            const numberFields = ['safety_temp_guard', 'safety_temp_limiter'];
            if (numberFields.includes(key)) {
              this.validateNumber(componentKey, value);
            }
          }

          this.validateTeleHeatingControlParameters(
            this.form.teleHeating.flow_temperature_control_parameter,
            'flow_temperature_control_parameter',
          );
          this.validateTeleHeatingControlParameters(
            this.form.teleHeating.return_temperature_control_parameter,
            'return_temperature_control_parameter',
          );
          break;
        case 'HEAT_PUMP_PRIMARY':
          for (const [key, value] of Object.entries(this.form.warmPumpPrimary)) {
            const componentKey = `warmPump.${key}`;
            if (key === 'energy_source_type' || key == 'heat_sink_type' || key === 'supply_potable_water_heating') {
              this.validateSelection(componentKey, value);
            }
          }
          break;
        case 'HEAT_PUMP_SECONDARY':
          for (const [key, value] of Object.entries(this.form.warmPumpSecondary)) {
            const componentKey = `warmPump.${key}`;
            if (key === 'energy_source_type' || key == 'heat_sink_type' || key === 'supply_potable_water_heating') {
              this.validateSelection(componentKey, value);
            }
          }
          break;
        case 'HEAT_EXCHANGER_PRIMARY':
          for (const [key, value] of Object.entries(this.form.heatExchangerPrimary)) {
            const componentKey = `heatExchanger.${key}`;
            if (key === 'terminal_temperature_difference' || (key === 'design_power' && value !== null)) {
              this.validateNumber(componentKey, value);
            }
          }
          break;
        case 'HEAT_EXCHANGER_SECONDARY':
          for (const [key, value] of Object.entries(this.form.heatExchangerSecondary)) {
            const componentKey = `heatExchanger.${key}`;
            if (key === 'terminal_temperature_difference' || (key === 'design_power' && value !== null)) {
              this.validateNumber(componentKey, value);
            }
          }
          break;
        case 'COMBINED_HEAT_POWER_PLANT':
          for (const [key, value] of Object.entries(this.form.chp)) {
            const componentKey = `chp.${key}`;
            const requiredNumberFields = ['th_power_max_out', 'el_power_max_out'];
            if (requiredNumberFields.includes(key)) {
              this.validateNumber(componentKey, value);
            }
          }
          break;
      }
    },
    // validate "ja/nein" options, check is if value is null.
    validateSelection(field: string, value: number | string | boolean | null) {
      switch (field) {
        case 'boiler.condensing':
          // accept explicit `false` as a valid selection — only treat null/undefined as missing
          if (value === null || value === undefined) {
            this.errors.push({ field, message: 'Brennwertgerät ist erforderlich' });
          }
          break;
        case 'waterHeating.type_of_pwh':
          if (!value) {
            this.errors.push({ field, message: 'Art der Warmwasserbereitung ist erforderlich' });
          }
          break;
        case 'warmPump.energy_source_type':
        case 'warmPump.heat_sink_type':
          if (!value) {
            this.errors.push({ field, message: `${this.getFieldNameByKey(field)} ist erforderlich` });
          }
          break;
        case 'warmPump.supply_potable_water_heating':
          if (value === null || value === undefined) {
            this.errors.push({ field, message: `${this.getFieldNameByKey(field)} ist erforderlich` });
          }
          break;
      }
    },
    // validate number fields, check if value is not on business rules range.
    // eslint-disable-next-line complexity
    validateNumber(field: string, value: any) {
      switch (field) {
        // boiler
        case 'boiler.safety_temp_guard':
          {
            // allow null/empty (optional). If user provides a value it must be a valid number between 0 and 130.
            if (value === null || value === undefined || value === '') return;
            const numVal = Number(value);
            if (!Number.isFinite(numVal) || numVal < 0 || numVal > 130) {
              this.errors.push({ field, message: 'Sicherheitstemperaturwächter sollte zwischen 0 und 130 liegen' });
            }
          }
          break;
        case 'boiler.safety_temp_limiter':
          {
            // allow null/empty (optional). If user provides a value it must be a valid number between 0 and 130.
            if (value === null || value === undefined || value === '') return;
            const numValLimiter = Number(value);
            if (!Number.isFinite(numValLimiter) || numValLimiter < 0 || numValLimiter > 130) {
              this.errors.push({ field, message: 'Sicherheitstemperaturbegrenzer sollte zwischen 0 und 130 liegen' });
            }
          }
          break;
        case 'boiler.power_min_out':
        case 'boiler.power_max_out':
          {
            if (value === null || value === undefined || value === '') return;
            const numValPower = Number(value);
            if (!Number.isFinite(numValPower) || numValPower < 0) {
              this.errors.push({
                field,
                message: `${this.getFieldNameByKey(field)} muss gleich oder größer als 0 sein`,
              });
            }
          }
          break;
        // water heating
        case 'waterHeating.potable_water_target_temp':
        case 'waterHeating.circulation_target_temp':
          {
            // allow null/empty (optional). If user provides a value it must be a valid number between 0 and 100.
            if (value === null || value === undefined || value === '') return;
            const numVal = Number(value);
            if (!Number.isFinite(numVal) || numVal < 0 || numVal > 100) {
              this.errors.push({
                field,
                message: `${this.getFieldNameByKey(field)} sollte zwischen 0 und 100 liegen.`,
              });
            }
          }
          break;
        case 'waterHeating.potable_water_temperature_tolerance':
        case 'waterHeating.circulation_temperature_tolerance':
          {
            // allow null/empty (optional). If user provides a value it must be a valid number between -100 and +100.
            if (value === null || value === undefined || value === '') return;
            const numValTolerance = Number(value);
            if (!Number.isFinite(numValTolerance) || numValTolerance < -100 || numValTolerance > 100) {
              this.errors.push({
                field,
                message: `${this.getFieldNameByKey(field)} sollten zwischen 0 und 100 liegen.`,
              });
            }
          }
          break;
        // buffer
        case 'buffer.upper_limit':
        case 'buffer.lower_limit':
          {
            // allow null/empty (optional). If user provides a value it must be a valid number between 0 and 130.
            if (value === null || value === undefined || value === '') return;
            const numVal = Number(value);
            // ensure it's a finite number within range
            if (!Number.isFinite(numVal) || numVal < 0 || numVal > 130) {
              this.errors.push({
                field,
                message: `${this.getFieldNameByKey(field)} muss zwischen 0 und 130 liegen.`,
              });
            }
          }
          break;
        // heating circuit
        case 'heatingCircuit.heating_circuit_building_year':
          if (value === null || value < 1 || String(Number(value)).length !== 4) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} muss ein gültiges Jahr sein.`,
            });
          }
          break;
        case 'heatingCircuit.control_parameter.summer_shutdown_temp':
        case 'heatingCircuit.control_parameter.nightly_reduced_temperature':
        case 'heatingCircuit.control_parameter.minimum_temperature':
        case 'heatingCircuit.control_parameter.maximum_temperature':
          if (value === null || !Number.isInteger(value)) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} muss eine Zahl sein`,
            });
          }
          break;
        case 'heatingCircuit.control_parameter.target_temperature':
        case 'heatingCircuit.control_parameter.room_target_temperature':
        case 'heatingCircuit.control_parameter.slope':
        case 'heatingCircuit.control_parameter.offset':
          {
            // disallow empty string / whitespace and require a finite number
            if (
              value === null ||
              value === undefined ||
              value === '' ||
              (typeof value === 'string' && value.trim() === '') ||
              !Number.isFinite(Number(value))
            ) {
              this.errors.push({
                field,
                message: `${this.getFieldNameByKey(field)} ist erforderlich.`,
              });
            }
          }
          break;
        // tele heating
        case 'teleHeating.safety_temp_guard':
        case 'teleHeating.safety_temp_limiter':
          {
            if (value === null || value === undefined || value === '') return;
            const numValTeleHeating = Number(value);
            if (!Number.isFinite(numValTeleHeating) || numValTeleHeating < 0 || numValTeleHeating > 130) {
              this.errors.push({
                field,
                message: `${this.getFieldNameByKey(field)} sollten zwischen 0 und 130 liegen.`,
              });
            }
          }
          break;
        case 'teleHeating.flow_temperature_control_parameter.target_temperature':
          if (!value || Number(value) < 0 || Number(value) > 130) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} sollten zwischen 0 und 130 liegen.`,
            });
          }
          break;
        case 'teleHeating.return_temperature_control_parameter.target_temperature':
          // allow explicit 0 — treat only null/undefined/empty as missing
          if (value === null || value === undefined || value === '' || Number(value) < 0 || Number(value) > 130) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} sollten zwischen 0 und 130 liegen.`,
            });
          }
          break;
        case 'heatExchanger.terminal_temperature_difference':
          if (value === null || value < 0 || value === '') {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} muss gleich oder größer als 0 sein.`,
            });
          }
          break;
        case 'heatExchanger.design_power':
          if (value !== null && value < 0) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} muss gleich oder größer als 0 sein.`,
            });
          }
          break;
        case 'chp.th_power_max_out':
        case 'chp.el_power_max_out':
          if (value === null && value < 0) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} muss gleich oder größer als 0 sein.`,
            });
          }
          break;
        // heating control outside temperature
        case 'heatingControl.heatedArea':
          if (value === null || !parseInt(value, 10) || value < 0) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} muss gleich oder größer als 1 sein.`,
            });
          }
          break;
        case 'heatingControl.forecastHours':
          if (value === null || value < 0 || !parseInt(value, 10) || value > 6) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} muss zwischen 1 und 6 liegen.`,
            });
          }
          break;
        case 'heatingControl.yearOfConstruction':
          if (value === null || value < 1500 || value > this.currentYear) {
            this.errors.push({
              field,
              message: `${this.getFieldNameByKey(field)} muss zwischen 1500 und ${this.currentYear} liegen.`,
            });
          }
          break;
      }
    },
    validateTeleHeatingControlParameters(
      { pointed_curve_parameter, target_temperature, type }: TemperatureControlParameter,
      field: string,
    ): void {
      if (!type) {
        this.errors.push({ field, message: 'Regelungsparameter ist erforderlich' });
        return;
      }

      if (type === 'constant_temperature') {
        this.validateNumber(`teleHeating.${field}.target_temperature`, target_temperature);
        return;
      }

      if (type === 'pointed_curve') {
        this.validateTeleHeatingPointedCurveParameters(pointed_curve_parameter, field);
      }
    },

    validateTeleHeatingPointedCurveParameters(pointed_curve_parameter: number[][] | null | undefined, field: string) {
      // This is for existing data, in case if we have less than 2 records
      if (!Array.isArray(pointed_curve_parameter) || pointed_curve_parameter.length < 2) {
        this.errors.push({ field, message: 'Bitte geben Sie mindestens 2 Wertepaare an' });
        return;
      }

      let allPairsFilled = true;
      // Check for empty/null/undefined values in each pair
      if (this.isAnyTemperaturePairEmpty(pointed_curve_parameter as number[][])) {
        allPairsFilled = false;
        this.errors.push({
          field,
          message: `Regelungsparameter der ${
            field.includes('flow') ? 'Vorlauftemperatur' : 'Rücklauftemperatur'
          }: Es dürfen keine leeren Wertepaare enthalten sein.`,
        });
      }

      if (allPairsFilled) {
        if (!this.hasUniquePairs(pointed_curve_parameter)) {
          this.errors.push({
            field,
            message: `Regelungsparameter der ${
              field.includes('flow') ? 'Vorlauftemperatur' : 'Rücklauftemperatur'
            }: Jedes Wertepaar muss eindeutig sein.`,
          });
        }
      }
    },
    isAnyTemperaturePairEmpty(pointed_curve_parameter: (number | string | null | undefined)[][]): boolean {
      return pointed_curve_parameter.some(
        (point) =>
          point[0] === null ||
          point[0] === undefined ||
          point[0] === '' ||
          point[1] === null ||
          point[1] === undefined ||
          point[1] === '',
      );
    },
    isTemperatureRangeValid(
      data: number[][] | null | undefined,
      minTarget = -100,
      maxTarget = 100,
      minEnv = 0,
      maxEnv = 200,
    ): boolean {
      if (!data) return false;
      return data.every(
        (obj) =>
          Number(obj[0]) >= minTarget &&
          Number(obj[0]) <= maxTarget &&
          Number(obj[1]) >= minEnv &&
          Number(obj[1]) <= maxEnv,
      );
    },
    // eslint-disable-next-line complexity
    getFieldNameByKey(key: string): string {
      switch (key) {
        case 'waterHeating.potable_water_target_temp':
          return 'Solltemperatur Warmwasser';
        case 'waterHeating.potable_water_temperature_tolerance':
          return 'Erlaubte Toleranz der Warmwasser Temperatur';
        case 'waterHeating.circulation_target_temp':
          return 'Solltemperatur Zirkulation';
        case 'waterHeating.circulation_temperature_tolerance':
          return 'Zulässige Toleranz der Zirkulationstemperatur';
        case 'buffer.upper_limit':
          return 'Obere Solltemperatur';
        case 'buffer.lower_limit':
          return 'Untere Solltemperatur';
        case 'boiler.power_min_out':
          return 'Minimale Leistungsabgabe';
        case 'boiler.power_max_out':
          return 'Maximale Leistungsabgabe';
        case 'heatingCircuit.heating_circuit_building_year':
          return 'Baujahr des versorgten Gebäudes';
        case 'heatingCircuit.control_parameter.summer_shutdown_temp':
          return 'Sommer-Abschalttemperatur';
        case 'heatingCircuit.control_parameter.nightly_reduced_temperature':
          return 'Nächtliche Temperaturabsenkung';
        case 'heatingCircuit.control_parameter.minimum_temperature':
          return 'Minimale Temperatur';
        case 'heatingCircuit.control_parameter.maximum_temperature':
          return 'Maximale Temperatur';
        case 'heatingCircuit.control_parameter.target_temperature':
          return 'Zieltemperatur';
        case 'heatingCircuit.control_parameter.offset':
          return 'Parallelverschiebung';
        case 'heatingCircuit.control_parameter.slope':
          return 'Steigung';
        case 'heatingCircuit.control_parameter.room_target_temperature':
          return 'Raum-Solltemperatur';
        case 'teleHeating.safety_temp_guard':
          return 'Sicherheitstemperaturwächter';
        case 'teleHeating.safety_temp_limiter':
          return 'Sicherheitstemperaturbegrenzer';
        case 'teleHeating.flow_temperature_control_parameter.target_temperature':
        case 'teleHeating.return_temperature_control_parameter.target_temperature':
          return 'Zieltemperatur';
        case 'heatExchanger.terminal_temperature_difference':
          return 'Temperaturdifferenz';
        case 'heatExchanger.design_power':
          return 'Nennleistung';
        case 'heatingControl.heatedArea':
          return 'Fläche';
        case 'heatingControl.forecastHours':
          return 'Vorhersagezeitraum in Stunden';
        case 'heatingControl.yearOfConstruction':
          return 'Baujahr Objekt';
        case 'warmPump.energy_source_type':
          return 'Energiequelle';
        case 'warmPump.heat_sink_type':
          return 'Typ des Kühlkörpers';
        case 'warmPump.supply_potable_water_heating':
          return 'Versorgt eine dezentrale Warmwasserbereitung';
        default:
          return '';
      }
    },
    addTemperatureField(context: string): void {
      if (context === 'heating-circuit') {
        this.form.heatingCircuit.control_parameter.env_flow_temp_points?.push([]);
      }
      if (context === 'tele-heating-flow') {
        this.form.teleHeating.flow_temperature_control_parameter.pointed_curve_parameter?.push([]);
      }
      if (context === 'tele-heating-return') {
        this.form.teleHeating.return_temperature_control_parameter.pointed_curve_parameter?.push([]);
      }
    },
    removeTemperatureField(index: number, context: string): void {
      if (context === 'heating-circuit') {
        const points = this.form.heatingCircuit.control_parameter.env_flow_temp_points;
        if (points && points.length > 0) {
          this.form.heatingCircuit.control_parameter.env_flow_temp_points = points.filter((point, idx) => {
            return idx !== index;
          });
        }
      }
      if (context === 'tele-heating-flow') {
        const points = this.form.teleHeating.flow_temperature_control_parameter.pointed_curve_parameter;
        if (points && points.length > 0) {
          this.form.teleHeating.flow_temperature_control_parameter.pointed_curve_parameter = points.filter(
            (point, idx) => {
              return idx !== index;
            },
          );
        }
      }
      if (context === 'tele-heating-return') {
        const points = this.form.teleHeating.return_temperature_control_parameter.pointed_curve_parameter;
        if (points && points.length > 0) {
          this.form.teleHeating.return_temperature_control_parameter.pointed_curve_parameter = points.filter(
            (point, idx) => {
              return idx !== index;
            },
          );
        }
      }
    },
    // this function checks if the items array of objects has unique "environment" values.
    hasUniqueValues(items: number[][]): boolean {
      const seen = new Set();
      for (const item of items) {
        if (seen.has(item[1])) {
          return false;
        }
        seen.add(item[1]);
      }
      return true;
    },
    hasUniquePairs(items: number[][]): boolean {
      const seen = new Set();
      for (const item of items) {
        if (seen.has(item.toString())) {
          return false;
        }
        seen.add(item.toString());
      }
      return true;
    },
    populateFormData(metadata: any) {
      this.form = cloneDeep(form); // This is to load the new form object everytime new component loads.
      if (metadata && Object.keys(metadata).length) {
        this.requestType = 'edit';
        this.assignMetadataToForm(metadata);
      } else {
        this.requestType = 'create';
      }
    },

    assignMetadataToForm(metadata: any) {
      switch (this.componentType) {
        case 'BOILER':
          this.form.boiler = metadata;
          break;
        case 'WARM_HEATING':
          this.form.waterHeating = metadata;
          break;
        case 'BUFFER':
          this.form.buffer = metadata;
          break;
        case 'TELE_HEATING':
          this.assignTeleHeatingMetadata(metadata);
          break;
        case 'HEATING_CIRCUIT':
          this.assignHeatingCircuitdata(metadata);
          break;
        case 'HEAT_PUMP_PRIMARY':
          this.form.warmPumpPrimary = metadata;
          break;
        case 'HEAT_PUMP_SECONDARY':
          this.form.warmPumpSecondary = metadata;
          break;
        case 'HEAT_EXCHANGER_PRIMARY':
          this.form.heatExchangerPrimary = metadata;
          break;
        case 'HEAT_EXCHANGER_SECONDARY':
          this.form.heatExchangerSecondary = metadata;
          break;
        case 'COMBINED_HEAT_POWER_PLANT':
          this.form.chp = metadata;
          break;
      }
    },

    assignTeleHeatingMetadata(metadata: any) {
      this.form.teleHeating = {
        ...metadata,
        flow_temperature_control_parameter: {
          ...metadata.flow_temperature_control_parameter,
          pointed_curve_parameter: metadata.flow_temperature_control_parameter.pointed_curve_parameter ?? [[], []],
        },
        return_temperature_control_parameter: {
          ...metadata.return_temperature_control_parameter,
          pointed_curve_parameter: metadata.return_temperature_control_parameter.pointed_curve_parameter ?? [[], []],
        },
      };
    },
    assignHeatingCircuitdata(metadata: any) {
      this.form.heatingCircuit = {
        ...metadata,
        control_parameter: {
          ...metadata.control_parameter,
          env_flow_temp_points: metadata.control_parameter.env_flow_temp_points ?? [[], []],
        },
      };
    },
  },
});
